import { Pipe, PipeTransform } from "@angular/core";
import { US_ReportSubscriptionExport } from "../api/models";

@Pipe({
  name: 'sortByLastUpdated'
})
export class SortByLastUpdated implements PipeTransform {
  transform(value: US_ReportSubscriptionExport[]): US_ReportSubscriptionExport[] {
    return value.sort((s1, s2) => {
      return Date.parse(s2.lastUpdate) - Date.parse(s1.lastUpdate);
    })
  }
}
